import React from 'react';
import './Services.css';
import siteContent from '../../data/siteContent';

const Services = () => {
  return (
    <section className="services-section" id="services">
      <div className="services-section__inner">
        <div className="section-heading">
          <h2 className="section-heading__title">SERVICES</h2>
          <p className="section-heading__text">
            From branding and websites to practical systems and reporting, KINI Consulting Group helps you build a stronger foundation for growth.
          </p>
        </div>

        <div className="services-grid">
          {siteContent.services.map((service) => (
            <article className="service-card" key={service.title}>
              <h3 className="service-card__title">{service.title}</h3>
              <ul className="service-card__list">
                {service.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              <a className="service-card__cta" href="#contact">
                Contact Us
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;